import React, { useState } from "react";

import Footer from "components/Footer";

// semantic-ui
import { Header, Container, Card, Segment, Button } from "semantic-ui-react";
import { Link } from "react-router";
import { isIkanoUser, isRestAPIUser, isWsAPIUser } from "services/self";
import { addNotification } from "./AlertPopup";
import { sendAccessRequestToUserGroup } from "services/accounts";
import { store } from "services/state";
import { REST, WEBSOCKET } from "utils/constants";

function Welcome() {
  const [loading, setLoading] = useState({
    rest: false,
    websocket: false,
  });
  const [isRequested, setIsRequested] = useState({
    rest: false,
    websocket: false,
  });

  const sendAccessRequest = async (apiType) => {
    const { UserId, email } = store.user;
    setLoading({ ...loading, [apiType]: true });
    try {
      if (!isRequested[apiType]) {
        await sendAccessRequestToUserGroup(UserId, email, apiType);
        setIsRequested({ ...isRequested, [apiType]: true });
        addNotification({
          negative: false,
          icon: "check",
          header: "Requested",
          content:
            "Your access request is successfully sent. One of the admins will approve your request. Please contact EEM API Gateway team for more details.",
        });
      }
    } catch (error) {
      addNotification({
        content: "Something went wrong. Please contact EEM API Gateway team.",
      });
    } finally {
      setLoading({ ...loading, [apiType]: false });
    }
  };
  return (
    <>
      <Segment
        vertical
        textAlign="left"
        style={{
          padding: "20px 10px",
          margin: "0px !important",
        }}
      >
        <article className="styles-article">
          <img
            className="styles-image"
            src="/custom-content/Welcome_icon4.jpg"
            alt="background"
          />
          <h1 className="styles-header">
            Welcome to the developer portal of Ikano Bank
          </h1>
        </article>
      </Segment>
      <Container>
        <Header
          as="h1"
          style={{
            padding: "35px 0px",
            marginLeft: "105px",
            marginRight: "105px",
            marginTop: "0px",
            marginBottom: "0px",
            borderTop: "1px solid lightgrey",
          }}
        >
          Explore our APIs
        </Header>

        <Card.Group centered>
          <Card
            raised
            link
            color="red"
            as={isRestAPIUser() ? Link : null}
            to="/apis"
          >
            <Card.Content>
              <Card.Header>REST APIs</Card.Header>
              <Card.Description>
                <p style={{ textAlign: "center" }}>
                  Explore the Swagger documentation for our REST APIs to explore
                  the available endpoints.
                </p>
                {!isRestAPIUser() && (
                  <Button
                    primary
                    fluid
                    loading={loading.rest}
                    positive={isRequested.rest}
                    onClick={() => sendAccessRequest(REST)}
                  >
                    {`${
                      !isRestAPIUser() && isRequested.rest
                        ? "Request sent"
                        : "Request for access"
                    }`}
                  </Button>
                )}
              </Card.Description>
            </Card.Content>
          </Card>

          <Card
            raised
            link
            color="yellow"
            as={isWsAPIUser() ? Link : null}
            to="/websocket-apis"
          >
            <Card.Content>
              <Card.Header>WebSocket APIs</Card.Header>
              <Card.Description>
                <p style={{ textAlign: "center" }}>
                  Check out documentation for asynchronous communication in UI
                  services with RESTful endpoints.
                </p>
                {!isWsAPIUser() && (
                  <Button
                    primary
                    fluid
                    loading={loading.websocket}
                    positive={isRequested.websocket}
                    onClick={() => sendAccessRequest(WEBSOCKET)}
                  >
                    {`${
                      !isWsAPIUser() && isRequested.websocket
                        ? "Request sent"
                        : "Request for access"
                    }`}
                  </Button>
                )}
              </Card.Description>
            </Card.Content>
          </Card>

          {isIkanoUser() && (
            <Card raised link color="orange" as={Link} to="/event-based-apis">
              <Card.Content>
                <Card.Header>Event based APIs</Card.Header>
                <Card.Description>
                  <p style={{ textAlign: "center" }}>
                    Discover user-friendly docs on Kafka-triggered event APIs to
                    enhance your understanding of dynamic communication.
                  </p>
                </Card.Description>
              </Card.Content>
            </Card>
          )}
        </Card.Group>
      </Container>
      <Footer />
    </>
  );
}

export default Welcome;
